export class GeneralError extends Error {
  public constructor(msg?: string) {
    super()

    this.message = `errors.${msg}` ?? 'errors.general'
  }
}
